import React , {Component} from 'react';
import { PnkHtmlForm } from '../../pnk-react/pnk-controls/pnk-html-form';
import ContactImg from '../../assets/images/contact.jfif';


export default class ContactPage extends Component{
    // constructor(){
    //     super();
    // }

    render(){
        return(
            <div className='contact-main'>
            <div className='container-fluid'>
            <div className='contact-head'>
            <h3>Contact Us</h3>
            </div>
            <div className='contact-main-div'>
            <div className='row'>
            <div className='col-12 col-sm-6 col-md-6 col-lg-6'>
            <div class="contact-img-div">
            <img src={ContactImg} alt='loading...'/>
            </div>
            <div className='contact-info'>
            <h4>Need help? We are here for you!</h4>
            <p>If you need help with booking a session or anything else, fill in the form and we will get back to you right away.</p>
            <p>OR</p>
            <div style={{textAlign:'center'}}>
            <div className='contact-call'>
            <p style={{fontWeight:'bold'}}>Call us:</p>
            <a href='tel:+918887757417'>+91-8887757417</a>
            </div>
            </div>
            </div>

            </div>
            <div className='col-12 col-sm-6 col-md-5 col-lg-5'>
            <PnkHtmlForm id="frmContactEntry" onsubmit={this.props.SaveContactEntryData} submitbtn="btnContactEntry" >
           
            <div class="row">
                <div class="col-12">
                    <div class="form-group">
                       
                        <input type="text" class="form-control form2-control-ausi"
                            id="txtUserFullName"
                            name="txtUserFullName"
                            placeholder="Full Name"
                            pnkvalidate="forceentry"
                            //pnkvalue={this.props.editDataObj.txtOrganizerName}
                            value={this.props.mystate.txtUserFullName}
                            onChange={this.props.HandleContactInput}
                            pnkdisplayerrormsg="Please Enter Your Name"

                        />
                    </div>
                </div>
                <div class="col-12">
                    <div class="form-group">
                       
                        <input type="text" class="form-control form2-control-ausi" id="txtUserEmail"
                            name="txtUserEmail"
                            placeholder="Email"
                            pnkvalidate="forceentry"
                         //   pnkvalue={this.props.editDataObj.txtContactEmail}
                            value={this.props.mystate.txtUserEmail}
                            onBlur={this.props.HandleContactInput}
                            pnkdisplayerrormsg="Please enter your email"
                        />
                    </div>
                </div>
                <div class="col-12">
                    <div class="form-group">
                       
                        <input type="text" class="form-control form2-control-ausi" id="txtUserContact"
                            name="txtUserContact"
                            placeholder="Contact Number"
                            pnkvalidate="forceentry"
                         //   pnkvalue={this.props.editDataObj.txtContactMobile}
                            value={this.props.mystate.txtUserContact}
                            onBlur={this.props.HandleContactInput}
                            pnkdisplayerrormsg="Please enter your number"
                        />
                    </div>
                </div>
                <div class="col-12">
                <div class="form-group">
                   
                    <textarea class="form-control form2-control-ausi" id="txtUserMessage"
                        name="txtUserMessage" rows="3"
                        placeholder="Message"
                        pnkvalidate="forceentry"
                     //   pnkvalue={this.props.editDataObj.txtContactMessage}
                        value={this.props.mystate.txtUserMessage}
                        onBlur={this.props.HandleContactInput}
                        pnkdisplayerrormsg="Please enter your message"
                    ></textarea>
                </div>
            </div>
            </div>

            <button class="btn add-organizer-btn pnkvalidatesubmit" id="btnContactEntry" name="save" onClick={() => this.props.SaveContactEntryData} >Contact Us</button>
        </PnkHtmlForm>

            </div>
            
            </div>
            </div>
            
            </div>
            
            </div>
        )
    }
}